var map = {
	"./AP018388.1-AP018389.1/contig1.png": 17563,
	"./AP018388.1-AP018389.1/contig2.png": 62528,
	"./BK059240.1-BK059241.1/contig1.png": 22623,
	"./BK059240.1-BK059241.1/contig2.png": 67972,
	"./BK059242.1-BK059244.1/contig1.png": 14848,
	"./BK059242.1-BK059244.1/contig2.png": 93179,
	"./BK059242.1-BK059244.1/contig3.png": 78962,
	"./JF750427.1-JF750430.1/contig1.png": 93314,
	"./JF750427.1-JF750430.1/contig2.png": 33049,
	"./JF750427.1-JF750430.1/contig3.png": 26800,
	"./JF750431.1-JF750489.1/contig10.png": 33737,
	"./JQ771300.1-JQ771305.1/contig1.png": 10255,
	"./JQ771300.1-JQ771305.1/contig2.png": 35764,
	"./JQ771300.1-JQ771305.1/contig3.png": 52445,
	"./JQ771300.1-JQ771305.1/contig4.png": 64546,
	"./JQ771300.1-JQ771305.1/contig5.png": 85675,
	"./JQ771306.1-JQ771309.1/contig1.png": 62533,
	"./JQ771306.1-JQ771309.1/contig2.png": 51054,
	"./JQ771306.1-JQ771309.1/contig3.png": 50551,
	"./JQ771310.1-JQ771316.1/contig1.png": 14518,
	"./JQ771310.1-JQ771316.1/contig2.png": 28493,
	"./KF754799.1-KF754803.1/contig1.png": 66634,
	"./KF754799.1-KF754803.1/contig2.png": 15617,
	"./KF754799.1-KF754803.1/contig3.png": 47352,
	"./KF754799.1-KF754803.1/contig4.png": 22519,
	"./KF754799.1-KF754803.1/contig5.png": 79502,
	"./KP053825.1-KP053887.1/contig1.png": 40864,
	"./KP053825.1-KP053887.1/contig2.png": 95899,
	"./KP053825.1-KP053887.1/contig3.png": 24517,
	"./KP053825.1-KP053887.1/contig4.png": 28461,
	"./KP053825.1-KP053887.1/contig5.png": 85956,
	"./KP053825.1-KP053887.1/contig6.png": 15871,
	"./KP053825.1-KP053887.1/contig7.png": 37782,
	"./KU992322.1-KX792461.1/contig10.png": 40465,
	"./KU992322.1-KX792461.1/contig11.png": 26248,
	"./KU992322.1-KX792461.1/contig12.png": 27875,
	"./KU992322.1-KX792461.1/contig13.png": 10298,
	"./MF070084.1-MF070102.1/contig10.png": 44235,
	"./MF611850.1-MF611851.1/contig1.png": 81745,
	"./MF611850.1-MF611851.1/contig2.png": 5498,
	"./MF989955.1-MF989959.1/contig1.png": 42220,
	"./MF989955.1-MF989959.1/contig2.png": 61223,
	"./MF989955.1-MF989959.1/contig3.png": 8734,
	"./MF989955.1-MF989959.1/contig4.png": 75473,
	"./MF989955.1-MF989959.1/contig5.png": 81608,
	"./MG947207.1-MG947209.1/contig1.png": 92432,
	"./MG947207.1-MG947209.1/contig2.png": 62283,
	"./MH410146.1-MH410148.1/contig1.png": 22220,
	"./MH410146.1-MH410148.1/contig2.png": 24871,
	"./MH455602.1-MH455606.1/contig1.png": 79146,
	"./MH455602.1-MH455606.1/contig2.png": 28129,
	"./MH455602.1-MH455606.1/contig3.png": 43512,
	"./MH591830.1-MH591857.1/contig10.png": 91735,
	"./MH591830.1-MH591857.1/contig11.png": 62510,
	"./MH591830.1-MH591857.1/contig12.png": 55250,
	"./MH591830.1-MH591857.1/contig13.png": 49980,
	"./MH591830.1-MH591857.1/contig14.png": 4851,
	"./MH591830.1-MH591857.1/contig15.png": 49642,
	"./MH591858.1-MH591878.1/contig1.png": 60100,
	"./MH591858.1-MH591878.1/contig10.png": 83710,
	"./MH591858.1-MH591878.1/contig11.png": 2023,
	"./MH591858.1-MH591878.1/contig12.png": 81964,
	"./MH591858.1-MH591878.1/contig13.png": 51061,
	"./MH591858.1-MH591878.1/contig14.png": 94554,
	"./MH591858.1-MH591878.1/contig15.png": 12131,
	"./MH591858.1-MH591878.1/contig16.png": 10504,
	"./MH591858.1-MH591878.1/contig2.png": 45375,
	"./MH591858.1-MH591878.1/contig3.png": 91574,
	"./MH591858.1-MH591878.1/contig4.png": 41545,
	"./MH591858.1-MH591878.1/contig5.png": 17344,
	"./MH591858.1-MH591878.1/contig6.png": 14907,
	"./MH591858.1-MH591878.1/contig7.png": 93362,
	"./MH591858.1-MH591878.1/contig8.png": 22517,
	"./MH591858.1-MH591878.1/contig9.png": 10892,
	"./MH931257.1-MH931259.1/contig1.png": 6778,
	"./MH931257.1-MH931259.1/contig2.png": 36945,
	"./MH931257.1-MH931259.1/contig3.png": 22728,
	"./MK562756.1-MZ328722.1/contig1.png": 46606,
	"./MK562756.1-MZ328722.1/contig2.png": 18405,
	"./MK990822.1-MK990823.1/contig1.png": 38397,
	"./MK990822.1-MK990823.1/contig2.png": 13510,
	"./MN104801.1-MN104803.1/contig1.png": 17396,
	"./MN104801.1-MN104803.1/contig2.png": 36303,
	"./MN104801.1-MN104803.1/contig3.png": 97286,
	"./MN114537.1-MN114539.1/contig1.png": 73402,
	"./MN114537.1-MN114539.1/contig2.png": 49649,
	"./MN114537.1-MN114539.1/contig3.png": 1256,
	"./MN400575.1-MN400587.1/contig1.png": 93215,
	"./MN400575.1-MN400587.1/contig10.png": 96495,
	"./MN400575.1-MN400587.1/contig11.png": 57478,
	"./MN400575.1-MN400587.1/contig12.png": 98717,
	"./MN400575.1-MN400587.1/contig13.png": 77588,
	"./MN400575.1-MN400587.1/contig2.png": 38564,
	"./MN400575.1-MN400587.1/contig3.png": 78509,
	"./MN400575.1-MN400587.1/contig4.png": 6002,
	"./MN400575.1-MN400587.1/contig5.png": 20219,
	"./MN400575.1-MN400587.1/contig6.png": 41888,
	"./MN400575.1-MN400587.1/contig7.png": 96713,
	"./MN400575.1-MN400587.1/contig8.png": 67806,
	"./MN400575.1-MN400587.1/contig9.png": 86119,
	"./MN400588.1-MN400593.1/contig1.png": 83808,
	"./MN400588.1-MN400593.1/contig2.png": 38843,
	"./MN400588.1-MN400593.1/contig3.png": 73490,
	"./MN400588.1-MN400593.1/contig4.png": 55053,
	"./MN400588.1-MN400593.1/contig5.png": 28900,
	"./MN400588.1-MN400593.1/contig6.png": 42463,
	"./MN432175.1-MN432178.1/contig1.png": 21535,
	"./MN432175.1-MN432178.1/contig2.png": 66884,
	"./MN432175.1-MN432178.1/contig3.png": 6829,
	"./MT075725.1-MT075726.1/contig1.png": 44245,
	"./MT075725.1-MT075726.1/contig2.png": 76894,
	"./MT122956.1-MT122957.1/contig1.png": 40213,
	"./MT122956.1-MT122957.1/contig2.png": 3486,
	"./MT122958.1-MT122959.1/contig1.png": 98017,
	"./MT122958.1-MT122959.1/contig2.png": 56938,
	"./MT122960.1-MT122961.1/contig1.png": 54335,
	"./MT122960.1-MT122961.1/contig2.png": 52708,
	"./MT122964.1-MT122965.1/contig1.png": 37439,
	"./MT122964.1-MT122965.1/contig2.png": 99140,
	"./MT122967.1-MT122968.1/contig1.png": 17484,
	"./MT122967.1-MT122968.1/contig2.png": 58244,
	"./MT122970.1-MT122971.1/contig1.png": 19661,
	"./MT122970.1-MT122971.1/contig2.png": 38038,
	"./MT122975.1-MT122976.1/contig1.png": 94181,
	"./MT122975.1-MT122976.1/contig2.png": 23822,
	"./MT122984.1-MT122985.1/contig1.png": 40767,
	"./MT122984.1-MT122985.1/contig2.png": 10852,
	"./MT122986.1-MT122987.1/contig1.png": 32779,
	"./MT122986.1-MT122987.1/contig2.png": 61488,
	"./MT318701.1-MT318710.1/contig1.png": 30852,
	"./MT318701.1-MT318710.1/contig10.png": 67966,
	"./MT318701.1-MT318710.1/contig2.png": 84063,
	"./MT318701.1-MT318710.1/contig3.png": 70774,
	"./MT318701.1-MT318710.1/contig4.png": 10857,
	"./MT318701.1-MT318710.1/contig5.png": 32736,
	"./MT318701.1-MT318710.1/contig6.png": 94715,
	"./MT318701.1-MT318710.1/contig7.png": 79890,
	"./MT318701.1-MT318710.1/contig8.png": 67093,
	"./MT318701.1-MT318710.1/contig9.png": 14828,
	"./MT320890.1-MT364442.1/contig1.png": 86075,
	"./MT320890.1-MT364442.1/contig2.png": 24096,
	"./MT411890.1-MT411891.1/contig1.png": 37569,
	"./MT411890.1-MT411891.1/contig2.png": 88586,
	"./MT797187.1-MT797195.1/contig1.png": 30021,
	"./MT797187.1-MT797195.1/contig2.png": 18542,
	"./MT797187.1-MT797195.1/contig3.png": 1687,
	"./MT797187.1-MT797195.1/contig4.png": 95896,
	"./MT797187.1-MT797195.1/contig5.png": 17025,
	"./MT797187.1-MT797195.1/contig6.png": 59594,
	"./MT797187.1-MT797195.1/contig7.png": 91507,
	"./MT797187.1-MT797195.1/contig8.png": 65588,
	"./MT797187.1-MT797195.1/contig9.png": 86717,
	"./MT821853.1-MT821854.1/contig1.png": 54859,
	"./MT821853.1-MT821854.1/contig2.png": 89456,
	"./MT921804.1-MT921805.1/contig1.png": 34427,
	"./MT921804.1-MT921805.1/contig2.png": 56096,
	"./MT921806.1-MT921807.1/contig1.png": 90507,
	"./MT921806.1-MT921807.1/contig2.png": 25104,
	"./MT921808.1-MT921809.1/contig1.png": 95251,
	"./MT921808.1-MT921809.1/contig2.png": 20760,
	"./MW122949.1-MW122951.1/contig1.png": 96885,
	"./MW122949.1-MW122951.1/contig2.png": 60158,
	"./MW122949.1-MW122951.1/contig3.png": 52295,
	"./MW122952.1-MW122954.1/contig1.png": 17936,
	"./MW122952.1-MW122954.1/contig2.png": 89227,
	"./MW122952.1-MW122954.1/contig3.png": 68098,
	"./MW122955.1-MW122956.1/contig1.png": 59883,
	"./MW122955.1-MW122956.1/contig2.png": 94480,
	"./MW122958.1-MW122959.1/contig1.png": 69303,
	"./MW122958.1-MW122959.1/contig2.png": 80572,
	"./MW122961.1-MW122963.1/contig1.png": 99936,
	"./MW122961.1-MW122963.1/contig2.png": 61915,
	"./MW122961.1-MW122963.1/contig3.png": 47090,
	"./MW122964.1-MW122965.1/contig1.png": 69461,
	"./MW122964.1-MW122965.1/contig2.png": 61329,
	"./MW122967.1-MW122969.1/contig1.png": 84296,
	"./MW122967.1-MW122969.1/contig2.png": 69571,
	"./MW122967.1-MW122969.1/contig3.png": 51994,
	"./MW122970.1-MW122972.1/contig1.png": 51488,
	"./MW122970.1-MW122972.1/contig2.png": 29819,
	"./MW122970.1-MW122972.1/contig3.png": 14994,
	"./MW122973.1-MW122975.1/contig1.png": 44618,
	"./MW122973.1-MW122975.1/contig2.png": 93601,
	"./MW122973.1-MW122975.1/contig3.png": 20888,
	"./MW122976.1-MW122977.1/contig1.png": 12779,
	"./MW122976.1-MW122977.1/contig2.png": 25136,
	"./MW122979.1-MW122981.1/contig1.png": 90413,
	"./MW122979.1-MW122981.1/contig2.png": 76438,
	"./MW122979.1-MW122981.1/contig3.png": 73375,
	"./MW122982.1-MW122984.1/contig1.png": 20002,
	"./MW122982.1-MW122984.1/contig2.png": 34009,
	"./MW122982.1-MW122984.1/contig3.png": 1904,
	"./MW432179.1-MW432180.1/contig1.png": 61924,
	"./MW432179.1-MW432180.1/contig2.png": 16575,
	"./MW477237.1-MW477238.1/contig1.png": 78171,
	"./MW477237.1-MW477238.1/contig2.png": 99840,
	"./MW594270.1-MW594272.1/contig1.png": 81956,
	"./MW594270.1-MW594272.1/contig2.png": 18815,
	"./MW594270.1-MW594272.1/contig3.png": 5526,
	"./MW594273.1-MW594275.1/contig1.png": 29590,
	"./MW594273.1-MW594275.1/contig2.png": 11213,
	"./MW594273.1-MW594275.1/contig3.png": 71268,
	"./MW594276.1-MW594278.1/contig1.png": 2848,
	"./MW594276.1-MW594278.1/contig2.png": 3560,
	"./MW594276.1-MW594278.1/contig3.png": 66354,
	"./MW594279.1-MW594281.1/contig1.png": 82593,
	"./MW594279.1-MW594281.1/contig2.png": 33610,
	"./MW594279.1-MW594281.1/contig3.png": 84371,
	"./MW594282.1-MW594284.1/contig1.png": 39642,
	"./MW594282.1-MW594284.1/contig2.png": 44401,
	"./MW594282.1-MW594284.1/contig3.png": 50536,
	"./MW717907.1-MW717909.1/contig1.png": 49956,
	"./MW717907.1-MW717909.1/contig2.png": 4607,
	"./MW717907.1-MW717909.1/contig3.png": 8278,
	"./MW854328.1-MW854330.1/contig1.png": 76131,
	"./MW854328.1-MW854330.1/contig2.png": 14152,
	"./MW854328.1-MW854330.1/contig3.png": 46193,
	"./MZ030725.1-MZ030727.1/contig1.png": 18114,
	"./MZ030725.1-MZ030727.1/contig2.png": 32121,
	"./MZ030725.1-MZ030727.1/contig3.png": 16368,
	"./MZ030728.1-MZ030730.1/contig1.png": 6869,
	"./MZ030728.1-MZ030730.1/contig2.png": 39518,
	"./MZ030728.1-MZ030730.1/contig3.png": 57831,
	"./MZ030734.1-MZ030736.1/contig1.png": 28006,
	"./MZ030734.1-MZ030736.1/contig2.png": 69245,
	"./MZ030734.1-MZ030736.1/contig3.png": 48116,
	"./MZ030737.1-MZ030739.1/contig1.png": 13108,
	"./MZ030737.1-MZ030739.1/contig2.png": 18223,
	"./MZ030737.1-MZ030739.1/contig3.png": 53030,
	"./MZ030740.1-MZ030742.1/contig1.png": 18800,
	"./MZ030740.1-MZ030742.1/contig2.png": 84203,
	"./MZ030740.1-MZ030742.1/contig3.png": 20546,
	"./MZ240733.1-MZ240735.1/contig1.png": 79882,
	"./MZ240733.1-MZ240735.1/contig2.png": 10465,
	"./MZ240733.1-MZ240735.1/contig3.png": 89336,
	"./MZ240736.1-MZ240738.1/contig1.png": 47864,
	"./MZ240736.1-MZ240738.1/contig2.png": 43475,
	"./MZ240736.1-MZ240738.1/contig3.png": 27914,
	"./MZ269392.1-MZ269412.1/contig10.png": 52103,
	"./MZ269392.1-MZ269412.1/contig11.png": 99614,
	"./MZ269392.1-MZ269412.1/contig12.png": 85365,
	"./MZ269392.1-MZ269412.1/contig13.png": 49452,
	"./MZ269392.1-MZ269412.1/contig14.png": 25699,
	"./MZ269392.1-MZ269412.1/contig15.png": 61594,
	"./MZ269392.1-MZ269412.1/contig16.png": 82705,
	"./MZ269392.1-MZ269412.1/contig17.png": 72488,
	"./MZ707540.1-MZ707543.1/contig1.png": 98859,
	"./MZ707540.1-MZ707543.1/contig2.png": 29008,
	"./MZ707540.1-MZ707543.1/contig3.png": 25913,
	"./MZ707540.1-MZ707543.1/contig4.png": 32838,
	"./MZ707544.1-MZ707547.1/contig1.png": 68267,
	"./MZ707544.1-MZ707547.1/contig2.png": 14768,
	"./MZ707544.1-MZ707547.1/contig3.png": 11673,
	"./MZ707544.1-MZ707547.1/contig4.png": 18598,
	"./MZ736638.1-MZ736639.1/contig1.png": 68297,
	"./MZ736638.1-MZ736639.1/contig2.png": 53682,
	"./MZ823411.1-MZ823414.1/contig1.png": 93841,
	"./MZ823411.1-MZ823414.1/contig2.png": 89082,
	"./MZ823411.1-MZ823414.1/contig3.png": 36835,
	"./MZ823411.1-MZ823414.1/contig4.png": 76940,
	"./MZ826160.1-MZ826163.1/contig1.png": 22063,
	"./MZ826160.1-MZ826163.1/contig2.png": 47572,
	"./MZ826160.1-MZ826163.1/contig3.png": 64253,
	"./MZ826160.1-MZ826163.1/contig4.png": 76354,
	"./MZ826164.1-MZ826166.1/contig1.png": 37082,
	"./MZ826164.1-MZ826166.1/contig3.png": 69384,
	"./MZ826271.1-MZ826273.1/contig1.png": 91444,
	"./MZ826271.1-MZ826273.1/contig2.png": 26703,
	"./MZ826271.1-MZ826273.1/contig3.png": 87686,
	"./MZ900993.1-MZ900994.1/contig1.png": 17113,
	"./MZ900993.1-MZ900994.1/contig2.png": 3106,
	"./MZ905370.1-MZ905372.1/contig1.png": 94872,
	"./MZ905370.1-MZ905372.1/contig2.png": 69363,
	"./MZ905370.1-MZ905372.1/contig3.png": 18602,
	"./MZ919331.1-MZ919336.1/contig1.png": 70265,
	"./MZ919331.1-MZ919336.1/contig2.png": 22082,
	"./MZ919331.1-MZ919336.1/contig3.png": 43211,
	"./MZ951174.1-MZ951176.1/contig1.png": 23606,
	"./MZ951174.1-MZ951176.1/contig2.png": 55373,
	"./MZ951174.1-MZ951176.1/contig3.png": 92132,
	"./NC_016004.1-NC_016006.1/contig1.png": 42370,
	"./NC_066968.1-OM066887.1/contig10.png": 30032,
	"./NC_066968.1-OM066887.1/contig11.png": 26937,
	"./NC_066968.1-OM066887.1/contig12.png": 78754,
	"./NC_068098.1-OP465225.1/contig1.png": 64642,
	"./NC_068098.1-OP465225.1/contig10.png": 50136,
	"./NC_068098.1-OP465225.1/contig11.png": 18401,
	"./NC_068098.1-OP465225.1/contig12.png": 69418,
	"./NC_068098.1-OP465225.1/contig13.png": 24627,
	"./NC_068098.1-OP465225.1/contig14.png": 24668,
	"./NC_068098.1-OP465225.1/contig15.png": 54085,
	"./NC_068098.1-OP465225.1/contig16.png": 82286,
	"./NC_068098.1-OP465225.1/contig17.png": 25303,
	"./NC_068098.1-OP465225.1/contig18.png": 74768,
	"./NC_068098.1-OP465225.1/contig19.png": 71673,
	"./NC_068098.1-OP465225.1/contig20.png": 14141,
	"./NC_068098.1-OP465225.1/contig21.png": 81108,
	"./NC_068098.1-OP465225.1/contig22.png": 55599,
	"./NC_068098.1-OP465225.1/contig23.png": 32934,
	"./OK037503.1-OK037504.1/contig1.png": 57903,
	"./OK037503.1-OK037504.1/contig2.png": 36436,
	"./OK326879.1-OK326881.1/contig1.png": 60547,
	"./OK326879.1-OK326881.1/contig2.png": 7336,
	"./OK326879.1-OK326881.1/contig3.png": 17553,
	"./OL348387.1-OL348388.1/contig1.png": 44431,
	"./OL348387.1-OL348388.1/contig2.png": 69940,
	"./OL450370.1-OL450371.1/contig1.png": 1237,
	"./OL450370.1-OL450371.1/contig2.png": 33886,
	"./OL703044.1-OL703045.1/contig1.png": 21791,
	"./OL703044.1-OL703045.1/contig2.png": 67140,
	"./OL789880.1-OL789881.1/contig1.png": 71795,
	"./OL789880.1-OL789881.1/contig2.png": 26040,
	"./OL857277.1-OL857286.1/contig1.png": 73574,
	"./OL857277.1-OL857286.1/contig10.png": 57940,
	"./OL857277.1-OL857286.1/contig2.png": 54781,
	"./OL857277.1-OL857286.1/contig3.png": 33652,
	"./OL857277.1-OL857286.1/contig4.png": 83563,
	"./OL857277.1-OL857286.1/contig5.png": 93058,
	"./OL857277.1-OL857286.1/contig6.png": 75993,
	"./OL857277.1-OL857286.1/contig7.png": 69744,
	"./OL857277.1-OL857286.1/contig8.png": 8484,
	"./OL857277.1-OL857286.1/contig9.png": 86606,
	"./OM219025.1-OM219027.1/contig1.png": 89688,
	"./OM219025.1-OM219027.1/contig2.png": 85299,
	"./OM219025.1-OM219027.1/contig3.png": 53386,
	"./OM461348.1-OM461350.1/contig1.png": 55603,
	"./OM461348.1-OM461350.1/contig2.png": 59992,
	"./OM461348.1-OM461350.1/contig3.png": 81121,
	"./OM461351.1-OM461353.1/contig1.png": 28134,
	"./OM461351.1-OM461353.1/contig2.png": 11901,
	"./OM461351.1-OM461353.1/contig3.png": 90772,
	"./ON012190.1-ON012191.1/contig1.png": 62653,
	"./ON012190.1-ON012191.1/contig2.png": 65094,
	"./ON012193.1-ON012194.1/contig1.png": 87753,
	"./ON012193.1-ON012194.1/contig2.png": 80690,
	"./ON012202.1-ON012203.1/contig1.png": 91221,
	"./ON012202.1-ON012203.1/contig2.png": 23870,
	"./ON012204.1-ON012205.1/contig1.png": 62049,
	"./ON012204.1-ON012205.1/contig2.png": 4618,
	"./ON024068.1-ON024069.1/contig1.png": 68683,
	"./ON024068.1-ON024069.1/contig2.png": 81040,
	"./ON024070.1-ON024071.1/contig1.png": 20165,
	"./ON024070.1-ON024071.1/contig2.png": 32014,
	"./ON303273.1-ON303274.1/contig1.png": 91581,
	"./ON303273.1-ON303274.1/contig2.png": 10374,
	"./ON398338.1-ON398340.1/contig1.png": 47063,
	"./ON398338.1-ON398340.1/contig2.png": 23132,
	"./ON398338.1-ON398340.1/contig3.png": 75397,
	"./ON507989.1-ON507990.1/contig1.png": 18064,
	"./ON507989.1-ON507990.1/contig2.png": 31883,
	"./ON603305.1-ON603308.1/contig1.png": 24137,
	"./ON603305.1-ON603308.1/contig2.png": 93170,
	"./ON603305.1-ON603308.1/contig3.png": 7995,
	"./ON603305.1-ON603308.1/contig4.png": 44132,
	"./ON631245.1-ON631247.1/contig1.png": 21662,
	"./ON631245.1-ON631247.1/contig3.png": 19916,
	"./ON674117.1-ON674118.1/contig1.png": 61813,
	"./ON674117.1-ON674118.1/contig2.png": 94462,
	"./ON758776.1-ON758777.1/contig1.png": 89095,
	"./ON758776.1-ON758777.1/contig2.png": 69036,
	"./ON758779.1-ON758780.1/contig1.png": 47092,
	"./ON758779.1-ON758780.1/contig2.png": 21583,
	"./ON890398.1-ON890401.1/contig1.png": 14089,
	"./ON890398.1-ON890401.1/contig2.png": 23378,
	"./ON890398.1-ON890401.1/contig3.png": 37595,
	"./ON890398.1-ON890401.1/contig4.png": 55940,
	"./ON930433.1-ON930434.1/contig1.png": 86841,
	"./ON930433.1-ON930434.1/contig2.png": 3906,
	"./ON951335.1-ON951336.1/contig1.png": 50877,
	"./ON951335.1-ON951336.1/contig2.png": 9638,
	"./ON960097.1-ON960098.1/contig1.png": 30187,
	"./ON960097.1-ON960098.1/contig2.png": 93987,
	"./OP177683.1-OP177685.1/contig1.png": 8148,
	"./OP177683.1-OP177685.1/contig2.png": 30607,
	"./OP177683.1-OP177685.1/contig3.png": 45510,
	"./OP251015.1-OP251020.1/contig1.png": 91862,
	"./OP251015.1-OP251020.1/contig2.png": 82541,
	"./OP251015.1-OP251020.1/contig3.png": 40036,
	"./OP251015.1-OP251020.1/contig4.png": 49979,
	"./OP251015.1-OP251020.1/contig5.png": 978,
	"./OP251015.1-OP251020.1/contig6.png": 66121,
	"./OP312068.1-OP312069.1/contig1.png": 6339,
	"./OP312068.1-OP312069.1/contig2.png": 21064,
	"./OP324798.1-OP324800.1/contig1.png": 38616,
	"./OP324798.1-OP324800.1/contig2.png": 13107,
	"./OP324798.1-OP324800.1/contig3.png": 57898,
	"./OP429117.1-OP429118.1/contig1.png": 71885,
	"./OP429117.1-OP429118.1/contig2.png": 40118,
	"./OP466722.1-OP466723.1/contig1.png": 97025,
	"./OP466722.1-OP466723.1/contig2.png": 48042,
	"./OP466724.1-OP466725.1/contig1.png": 50165,
	"./OP466724.1-OP466725.1/contig2.png": 64414,
	"./OP649454.1-OP649456.1/contig1.png": 39672,
	"./OP649454.1-OP649456.1/contig2.png": 85427,
	"./OP649454.1-OP649456.1/contig3.png": 46570,
	"./OP800433.1-OP800434.1/contig1.png": 15938,
	"./OP800433.1-OP800434.1/contig2.png": 26206,
	"./OP805353.1-OP805354.1/contig1.png": 59917,
	"./OP805353.1-OP805354.1/contig2.png": 78294,
	"./OP895669.1-OP895670.1/contig1.png": 73914,
	"./OP895669.1-OP895670.1/contig2.png": 98577,
	"./OP973783.1-OP973810.1/contig1.png": 11671,
	"./OP973783.1-OP973810.1/contig10.png": 72279,
	"./OP973783.1-OP973810.1/contig11.png": 72782,
	"./OP973783.1-OP973810.1/contig12.png": 613,
	"./OP973783.1-OP973810.1/contig13.png": 48348,
	"./OP973783.1-OP973810.1/contig14.png": 45747,
	"./OP973783.1-OP973810.1/contig15.png": 30186,
	"./OP973783.1-OP973810.1/contig16.png": 71265,
	"./OP973783.1-OP973810.1/contig17.png": 27755,
	"./OP973783.1-OP973810.1/contig18.png": 41295,
	"./OP973783.1-OP973810.1/contig19.png": 59750,
	"./OP973783.1-OP973810.1/contig20.png": 98726,
	"./OP974165.1-OP974166.1/contig1.png": 46710,
	"./OP974165.1-OP974166.1/contig2.png": 59186,
	"./OQ001564.1-OQ001565.1/contig1.png": 8261,
	"./OQ001564.1-OQ001565.1/contig2.png": 37902,
	"./OQ101613.1-OQ101615.1/contig1.png": 60714,
	"./OQ101613.1-OQ101615.1/contig2.png": 9697,
	"./OQ101613.1-OQ101615.1/contig3.png": 25080,
	"./OQ259535.1-OQ259536.1/contig1.png": 28169,
	"./OQ259535.1-OQ259536.1/contig2.png": 97202,
	"./OQ539548.1-OQ539550.1/contig1.png": 96735,
	"./OQ539548.1-OQ539550.1/contig2.png": 66820,
	"./OQ539548.1-OQ539550.1/contig3.png": 9325,
	"./OQ621745.1-OQ621746.1/contig1.png": 26357,
	"./OQ621745.1-OQ621746.1/contig2.png": 59006,
	"./OQ754376.1-OQ754378.1/contig1.png": 12349,
	"./OQ754376.1-OQ754378.1/contig2.png": 48961,
	"./OQ754376.1-OQ754378.1/contig3.png": 27832,
	"./OQ947725.1-OQ947727.1/contig1.png": 11970,
	"./OQ947725.1-OQ947727.1/contig2.png": 94905,
	"./OQ947725.1-OQ947727.1/contig3.png": 88656,
	"./OR139599.1-OR139605.1/contig1.png": 10250,
	"./OR139599.1-OR139605.1/contig2.png": 24481,
	"./OR139599.1-OR139605.1/contig3.png": 3352,
	"./OR139599.1-OR139605.1/contig4.png": 52343,
	"./OR139599.1-OR139605.1/contig5.png": 6766,
	"./OR139599.1-OR139605.1/contig6.png": 77125,
	"./OR139599.1-OR139605.1/contig7.png": 94236,
	"./OR168698.1-OR168699.1/contig1.png": 6399,
	"./OR168698.1-OR168699.1/contig2.png": 51748,
	"./PQ275616.1-PQ275627.1/contig1.png": 80436,
	"./PQ275616.1-PQ275627.1/contig10.png": 23278,
	"./PQ275616.1-PQ275627.1/contig11.png": 6423,
	"./PQ275616.1-PQ275627.1/contig2.png": 1903,
	"./PQ275616.1-PQ275627.1/contig3.png": 20358,
	"./PQ275616.1-PQ275627.1/contig4.png": 22777,
	"./PQ275616.1-PQ275627.1/contig5.png": 16528,
	"./PQ275616.1-PQ275627.1/contig6.png": 30347,
	"./PQ275616.1-PQ275627.1/contig7.png": 39842,
	"./PQ275616.1-PQ275627.1/contig8.png": 61221,
	"./PQ275616.1-PQ275627.1/contig9.png": 8956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43969;